import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import Login from './pages/Login';
import StatusPage from './pages/StatusPage';
import WagtailPage from './pages/WagtailPage';

const PoolBetPage = lazy(() => import('./pages/PoolBetPage'));
const PoolListPage = lazy(() => import('./pages/PoolListPage'));
const Profile = lazy(() => import('./pages/Profile'));

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Suspense
          fallback={
            <div className="flex items-center justify-center py-12">
              <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
            </div>
          }
        >
          <Routes>
            {/* Layout wrapper for main app */}
            <Route path="/" element={<Layout />}>
              {/* Public auth routes */}
              <Route path="login" element={<Login />} />

              {/* Home page (custom) */}
              <Route index element={<HomePage />} />

              {/* Status page */}
              <Route path="status" element={<StatusPage />} />

              {/* Pool Bet pages (protected) */}
              <Route
                path="pool"
                element={
                  <ProtectedRoute>
                    <PoolListPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="pool/:slug"
                element={
                  <ProtectedRoute>
                    <PoolBetPage />
                  </ProtectedRoute>
                }
              />

              {/* Protected pages */}
              <Route
                path="profile"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />

              {/* All CMS pages - catch-all route */}
              <Route path="*" element={<WagtailPage />} />
            </Route>
          </Routes>
        </Suspense>
        <ToastContainer position="top-right" />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
